import { Injectable } from '@angular/core';
import { DottedKey } from '../../../../core/field-definitions/entities/field-definition.entity';
import { ExtendedProfileField } from '../../../../core/profiles/entities/extended-profile-field.entity';
import { Comparable } from '../../../../helpers/entities/comparable.interface';
import { Trackable } from '../../../../helpers/entities/trackable.interface';
import { Cell } from '../../components/cells/_base/table-cell.entity';
import { ColumnDef } from '../../entities/column-definition.entity';
import { ColumnType } from '../../entities/column-type.entity';
import { ColumnWidth } from '../../entities/column-width.entity';
import { SortOptionsHelper } from '../../helpers/sort-options.helper';

@Injectable({ providedIn: 'root' })
export abstract class ProfileFieldColumnService<T extends Trackable & Comparable> {
    protected abstract readonly WIDTH: ColumnWidth;

    // Override sorting based on FieldDefinition
    // Used for disabling sort on certain calculated fields
    protected abstract readonly DISABLE_SORT: boolean;

    getColumn(profileField: ExtendedProfileField): ColumnDef<ColumnType, T> {
        return new ColumnDef({
            key: profileField.DottedKey,
            translateLabel: profileField.DisplayLabel,
            mapper: this.getMapper(profileField),
            width: this.WIDTH,
            fieldSelectDottedKeys: this.getFieldSelectDottedKeys(profileField),
            sortType: SortOptionsHelper.getSortType(profileField.FieldDefinition.Type),
            sortable: this.DISABLE_SORT ? false : profileField.FieldDefinition.Sortable
        });
    }

    protected getFieldSelectDottedKeys(profileField: ExtendedProfileField): DottedKey[] {
        return [this.getTopLevelDottedKey(profileField)];
    }

    private getTopLevelDottedKey(profileField: ExtendedProfileField): DottedKey {
        return profileField.DottedKey?.split('.').slice(0, 2).join('.') as DottedKey;
    }

    protected abstract getMapper(profileField: ExtendedProfileField): (item: T) => Cell;
}
